import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              {contactData.subtitle}
            </p>
          </div>

          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {contactData.desc}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-800 truncate">{contactData.email}</p>
                </div>
              </div>

              <div className="flex-1 flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 flex-shrink-0">
                  <i className="ri-chat-3-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-500 mb-0.5">投稿咨询</p>
                  <p className="text-sm font-medium text-foreground-800 truncate">{contactData.qq}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}